import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  DataListModel,
  IKeyValueInterface,
  WeGoAuthorizedLink,
  Permission,
  Entity,
  PermissionType
} from '../../shared/config';
import { AdminOfCustomerService } from '../models/admin-of-customer.service';
import { AdminOfCustomerModel } from '../models/admin-of-customer.model';
import { RoleAvailabilityModel } from '../../roleavailability/models/roleavailability.model';
import { retry } from 'rxjs/operator/retry';
import { PersonService } from '../../person/models/person.service';
import { CustomerService } from '../../customer/models/customer.service';
import { CustomerAdminInvitationModel } from '../../admin-invite-popup/models/admin-to-invite.model';

@Component({
  selector: 'wego-admin-of-customer',
  template: require('../views/admin-of-customer-list.component.html'),
  providers: [AdminOfCustomerService, PersonService, CustomerService]
})
export class AdminOfCustomerListComponent implements OnInit {
  inviteTitle: any;
  ToggleRoleName: string;
  ToggleUserName: string;
  ToggleAddRole: boolean;
  ToggleRoleHashId: string;
  ToggleRolePersonHashID: string;
  roleAvailabilityList: RoleAvailabilityModel[];
  DataListModel: DataListModel;
  sub: any;
  customerHashId: string;
  customerAdminList: AdminOfCustomerModel[];
  errorModel: IKeyValueInterface[];
  roleColumns: number = 0;
  apiErrorMsg: string;
  isLoading: boolean;
  deletePersonMasterHashId: string;
  resetPasswordPersonHashId: string;
  message: string;
  errorMessage: string;
  customerName: string;
  urlDefaultPage: string;
  urlCustomerList: string;
  isParentCheck: boolean;
  isMultipleDelete: boolean;
  deleteMessage: string;
  validateMessage: string;
  private popupMsg: string;
  private popupTitle: string;
  private module: string;
  private breadCrumbList: string;
  private customerList: string;
  toggleRoleMsg: string;
  toggleRoleTitle: string;
  addCustomerAdminLink: WeGoAuthorizedLink;
  adminDependencyvalidationMessage: string;
  adminDependencyModelTitle: string;

  @ViewChild('alertModal') public alertModal: any;
  @ViewChild('resetPasswordModal') public resetPasswordModal: any;
  @ViewChild('inActiveModal') public inActiveModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('toggleRolePopup') public toggleRolePopup: any;
  @ViewChild('inviteAdminModal') public inviteAdminModal: any;
  @ViewChild('adminDependencyModal') public adminDependencyModal: any;

  constructor(
    private adminOfCustomerService: AdminOfCustomerService,
    private personService: PersonService,
    private customerService: CustomerService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {}

  get isAnyChecked(): boolean {
    if (this.customerAdminList) {
      let isCheck = this.customerAdminList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.customerAdminList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else this.isParentCheck = false;
      } else {
        this.isParentCheck = false;
      }

      return isCheck;
    } else {
      this.isParentCheck = false;
      return false;
    }
  }

  get isDeleteAccess(): boolean {
    if (this.customerAdminList) {
      return this.customerAdminList.some(x => x.isDeletable);
    } else {
      return false;
    }
  }

  ngOnInit() {
    this.module = this.translate.instant('LblCustomerAdmin');
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.customerList = this.translate.instant('LblListPage', [
      this.translate.instant('LblCustomer')
    ]);
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ['userName', 'firstName', 'lastName'];
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlCustomerList = this.authService.GetURL(
      ApplicationRouteURL.URL_CUSTOMER_LIST
    );
    this.inviteTitle =
      this.translate.instant('LblInvite') +
      ' ' +
      this.translate.instant('LblCustomerAdmin');
    this.adminDependencyModelTitle = this.translate.instant(
      'LblAdminDependencyAlert'
    );

    this.adminDependencyvalidationMessage = this.translate.instant(
      'LblAdminDependencyValidation'
    );

    this.sub = this.activeRoute.params.subscribe(params => {
      this.customerHashId = params['id'] || '';
      if (this.customerHashId != '') {
        this.addCustomerAdminLink = new WeGoAuthorizedLink(
          '',
          Permission.PR_CUSTOMER_ADMIN_OVERVIEW,
          PermissionType.INSERT,
          'btn btn-highlight navbar-right',
          'LblInvite',
          Entity.CUSTOMER,
          this.customerHashId
        );

        this.GetCustomerDetails();
      }
    });
  }

  public SuccessAdminDependencyModalClick() {
    this.adminDependencyModal.hide();
  }

  public RoleAvailabilityList() {
    this.isLoading = true;
    if (this.customerHashId) {
      this.adminOfCustomerService
        .GetAllRoleAvailability(new DataListModel(), this.customerHashId)
        .subscribe(
          res => {
            this.roleAvailabilityList = res.data;
            this.roleColumns = this.roleAvailabilityList.length;
            this.GetAdminOfCustomerList();
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          }
        );
    }
  }

  public GetCustomerDetails() {
    if (this.customerHashId) {
      this.isLoading = true;
      this.customerService
        .GetCustomerBasicDetail(this.customerHashId)
        .subscribe(
          res => {
            if (res.data) {
              this.customerName = res.data.entityName;
              this.RoleAvailabilityList();
            }
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          }
        );
    }
  }

  public GetAdminOfCustomerList() {
    this.isLoading = true;
    this.adminOfCustomerService
      .GetAdminOfCustomerList(this.customerHashId, this.DataListModel)
      .subscribe(
        res => {
          this.customerAdminList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.customerAdminList = [];
          this.DataListModel.infoMessage = error;
          this.isLoading = false;
        }
      );
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetAdminOfCustomerList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetAdminOfCustomerList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetAdminOfCustomerList();
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetAdminOfCustomerList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.adminOfCustomerService
      .ExportAdminOfCustomerList(this.customerHashId, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = 'CustomerAdmin' + new Date().toISOString() + '.csv';
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public DeleteAdminOfCustomer(deleteAdminOfCustomerList: string[]) {
    this.isLoading = true;
    this.adminOfCustomerService
      .DeleteAdminOfCustomer(this.customerHashId, deleteAdminOfCustomerList)
      .subscribe(
        res => {
          if (!res.data) {
            this.adminDependencyvalidationMessage = this.translate.instant(
              'LblAdminDependencyValidationOnDelete'
            );
            this.adminDependencyModal.show();
            this.isLoading = false;
          } else {
            this.DataListModel.currentPage = 1;
            this.GetAdminOfCustomerList();
            this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [
              this.module
            ]);
            this.ShowSuccessPopup();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnParentCheck(isChecked: boolean) {
    this.customerAdminList
      .filter(x => x.isDeletable)
      .forEach(x => (x.isChecked = isChecked));
  }

  public ShowAlertModal(deletePersonMasterHashId?: string): void {
    if (deletePersonMasterHashId) {
      this.deleteMessage = this.translate.instant(
        'LblRecordDeleteConfirmation',
        [this.module]
      );
      this.isMultipleDelete = false;
      this.deletePersonMasterHashId = deletePersonMasterHashId;
    } else {
      this.deleteMessage = this.translate.instant(
        'LblRecordMultiplDeleteConfirmation',
        [this.module]
      );
      this.isMultipleDelete = true;
    }
    this.alertModal.show();
  }

  public HideAlertModal(): void {
    this.deletePersonMasterHashId = '';
    this.alertModal.hide();
  }

  public SuccessAlertModalClick(): void {
    let deleteAdminOfCustomerList: any[];
    if (this.isMultipleDelete)
      deleteAdminOfCustomerList = this.customerAdminList
        .filter(x => x.isChecked)
        .map(x => x.personMasterHashId);
    else deleteAdminOfCustomerList.push(this.deletePersonMasterHashId);

    this.DeleteAdminOfCustomer(deleteAdminOfCustomerList);
    this.alertModal.hide();
  }

  // Add Customer admin popup
  public ShowAddAdminOfCustomerModal() {
    this.ShowInviteAdminModal();
  }

  public ToggleRoleAvailability(
    personHashID: string,
    roleHashId: string,
    personRolesHashIds: string[],
    roleName: string,
    userName: string
  ) {
    this.ToggleRolePersonHashID = personHashID;
    this.ToggleRoleHashId = roleHashId;
    this.ToggleUserName = userName;
    this.ToggleRoleName = roleName;

    if (this.CheckRole(personRolesHashIds, roleHashId)) {
      this.toggleRoleMsg = this.translate.instant('LblDoYouWantToRemove', [
        userName,
        roleName
      ]);
      this.ToggleAddRole = false;
      this.ShowToggleRolePopup();
    } else {
      this.toggleRoleMsg = this.translate.instant('LblDoYouWantToAdd', [
        userName,
        roleName
      ]);
      this.ToggleAddRole = true;
      this.ShowToggleRolePopup();
    }
  }

  public ShowToggleRolePopup(): void {
    this.toggleRolePopup.show();
  }

  public HideToggleRolePopup(): void {
    this.ToggleRolePersonHashID = '';
    this.ToggleRoleHashId = '';
    this.ToggleUserName = '';
    this.ToggleRoleName = '';

    this.toggleRolePopup.hide();
  }
  public ConfirmToggleRolePopup(): void {
    if (this.ToggleAddRole) {
      this.adminOfCustomerService
        .AddAdminOfCustomerRole(
          this.customerHashId,
          this.ToggleRolePersonHashID,
          this.ToggleRoleHashId
        )
        .subscribe(
          res => {
            this.GetAdminOfCustomerList();
            this.popupMsg = this.translate.instant('LblRoleAddedSuccess', [
              this.ToggleUserName,
              this.ToggleRoleName
            ]);
            this.HideToggleRolePopup();
            this.ShowSuccessPopup();
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
            this.HideToggleRolePopup();
          }
        );
    } else {
      this.adminOfCustomerService
        .DeleteAdminOfCustomerRole(
          this.customerHashId,
          this.ToggleRolePersonHashID,
          this.ToggleRoleHashId
        )
        .subscribe(
          res => {
            if (!res.data) {
              this.HideToggleRolePopup();
              this.adminDependencyvalidationMessage = this.translate.instant(
                'LblAdminDependencyValidation'
              );
              this.adminDependencyModal.show();
            } else {
              this.GetAdminOfCustomerList();
              this.popupMsg = this.translate.instant('LblRoleDeletedSuccess', [
                this.ToggleUserName,
                this.ToggleRoleName
              ]);
              this.HideToggleRolePopup();
              this.ShowSuccessPopup();
            }
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
            this.HideToggleRolePopup();
          }
        );
    }
  }

  //Reset company admin password
  public ResetPersonPassword(personHashID: string) {
    this.personService.ResetPersonPassword(personHashID).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblResetPasswordSuccess');
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant('LblResetPasswordFailure');
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ShowResetPasswordModal(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
    this.resetPasswordModal.show();
  }

  public HideResetPasswordModal(): void {
    this.resetPasswordPersonHashId = '';
    this.resetPasswordModal.hide();
  }
  public SuccessResetPasswordModalClick(): void {
    this.resetPasswordModal.hide();
    this.ResetPersonPassword(this.resetPasswordPersonHashId);
  }

  public ResendActivationMail(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.personService.ReSendActivationMail(personHashID).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant(
            'LblResendActivationMailSuccess'
          );
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant(
            'LblResendActivationMailFailure'
          );
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }
  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.toggleRolePopup.hide();
  }

  public ShowInviteAdminModal(): void {
    this.inviteAdminModal.availableRoles = JSON.parse(
      JSON.stringify(this.roleAvailabilityList)
    );
    this.inviteAdminModal.availablePersons = '';
    this.inviteAdminModal.show();
  }

  public HideInviteAdminModal(): void {
    this.inviteAdminModal.hide();
  }

  public SuccessInviteAdminModalClick($event: any): void {
    console.log($event);

    let adminInvitation = new CustomerAdminInvitationModel();
    adminInvitation.emailAddress = $event.emailAddress;
    adminInvitation.personHashId = $event.personHashId;
    adminInvitation.roleHashIdList = $event.roleHashIdList;
    adminInvitation.customerHashId = this.customerHashId;

    this.adminOfCustomerService
      .InviteAdminOfCustomer(adminInvitation)
      .subscribe(
        res => {
          if (res.data) {
            this.popupMsg = this.translate.instant('LblInvitationMailSuccess');
            this.HideInviteAdminModal();
            this.ShowSuccessPopup();
          } else {
            this.inviteAdminModal.errorModel = res.error;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
          this.HideInviteAdminModal();
        }
      );
  }

  public SearchEmailAddress($event: any): void {
    let emailAddress = $event.emailAddress;
    this.isLoading = true;
    this.adminOfCustomerService
      .GetPersonListToInvite(this.customerHashId, emailAddress)
      .subscribe(
        res => {
          if (res.data) {
            this.inviteAdminModal.availablePersons = res.data;
            this.inviteAdminModal.errorModel = [];
          } else {
            this.inviteAdminModal.errorModel = res.error;
          }
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public CheckRole(existingArray: string[], currentRole: string) {
    return existingArray.some(x => x == currentRole);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-of-customer/components/admin-of-customer-list.component.ts